import { render } from "./sucaiListPage.vue?vue&type=template&id=1d45c484&scoped=true"
import script from "./sucaiListPage.vue?vue&type=script&lang=js"
export * from "./sucaiListPage.vue?vue&type=script&lang=js"

import "./sucaiListPage.vue?vue&type=style&index=0&id=1d45c484&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d45c484"]])

export default __exports__